export default function install(Vue) {
  Vue.prototype.$setIcon = function(url) {
    var link = document.createElement("link"),
      oldLink = document.getElementById("dynamic-favicon");
    link.id = "dynamic-favicon";
    link.rel = "icon";
    if (url && !url.startsWith("http:") && !url.startsWith("https:"))
      link.href = "https:" + url;
    else link.href = url;
    if (oldLink) {
      document.head.removeChild(oldLink);
    }
    document.head.appendChild(link);
  };
}
